"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendResetPasswordEmail = void 0;
class SendResetPasswordEmail {
    constructor(accountService) {
        this.accountService = accountService;
    }
    execute(request) {
        return this.accountService.sendResetPasswordEmail(request);
    }
}
exports.SendResetPasswordEmail = SendResetPasswordEmail;
